import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import EditOwnerModel from "../../Components/Users/EditUserModel";
import WhitelabelSettingsModel from "../../Components/Users/WhitelabelSettingsModel";
import ViewDetailModel from "../../Components/Users/ViewDetail";
import UploadLogo from "../../Components/Users/UploadLogo";
import Table from "../../Components/Transactions/PartnerWiseCollectionTable";


const RecentUsed = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [fetchData, setFetchData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("mobile");
  const [editUser, setEditUser] = useState(false);
  const [uploadLogo, setUploadLogo] = useState(false);
  const [addCharges, setAddCharges] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [showWhitelabelSettings, setShowWhitelabelSettings] = useState(false);
  const [type, setType] = useState(1);
  // const [startDate, setStartDate] = useState(
  //   moment(new Date()).subtract(31, "days").format("YYYY-MM-DD")
  // );

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t, i18n } = useTranslation();

  // const initialValues = {
  //   name: "",
  //   filterVal: filterValue,
  //   startDate: moment(new Date()).format("YYYY-MM-DD"),
  //   endDate: moment(new Date()).subtract(-31, "days").format("YYYY-MM-DD"),
  // };

  const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    //body.append("type", type);
    return await axios.post(`${Config.apiUrl}/getpartnercollection`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getOwnersSuccess = (res) => {
    if (res.data.status == "NOK" || res.data.data == false) {
      error = true;
    } else setFetchData(res.data.data);
  };

  const getOwnersError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getOwnersMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getOwnersSuccess,
    onError: getOwnersError,
  });

  //console.log (fetchData);
  // console.log (error);
  // console.log (isLoading);

  useEffect(() => {
    const handler = setTimeout(() => {
      getOwnersMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getOwnersMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };

  // --------Upload logo---------
  const uploadLogoFunction = async (values) => {
    const formData = new FormData();
    formData.append("clientId", values.id);
    formData.append("logo", values.ownerLogoImage);

    return await axios.post(`${Config.apiUrl}/uploadlogo`, formData, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const onUploadLogoSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Logo uploaded successfully!");
      setFetchData((prevData) =>
        prevData.map((owner) =>
          owner.id === selectedData.id
            ? { ...owner, logoPath: data.data.logoPath }
            : owner
        )
      );
    } else {
      toast.error(data?.data?.msg || "An error occurred.");
    }
    setUploadLogo(false);
    setSelectedData("");
  };

  const onUploadLogoError = (error) => {
    toast.error(error?.response?.data?.msg || "An error occurred.");
    setUploadLogo(false);
  };
  const { isLoading: uploadLogoLoading, mutate: uploadLogoMutate } =
    useMutation(uploadLogoFunction, {
      onSuccess: onUploadLogoSuccess,
      onError: onUploadLogoError,
    });

  //------- Edit Single Entry -------
  const EditOwnerFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("name", values.name);
    body.append("mobile", values.mobile);
    body.append("status", values.status);
    body.append("panNumber", values.panNumber);
    body.append("isBankDetailsShown", values.isBankDetailsShown);
    body.append("paymentGateway", values.paymentGateway);
    return await axios.post(`${Config.apiUrl}/editowner`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onEditEntrySuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      // getOwnersMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setEditUser(false);
    setFetchData(data?.data?.data);
  };
  const onEditEntryError = (data) => {
    setSelectedData("");
    setEditUser(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };
  const { isLoading: editEntryLoading, mutate: editOwnerMutate } = useMutation(
    EditOwnerFunction,
    {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    }
  );

    //------- Edit Whitelabel Settings -------
    const editWhiteblabelSettings = async (values) => {
      const body = new FormData();
      body.append("id", values.id);
      body.append("template", values.template);
      body.append("footer", values.footer);

      return await axios.post(`${Config.apiUrl}/editwhitelabelsettings`, body, {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    };
    const onEditWhitelabelSettingSuccess = (data) => {
      if (data?.data?.status == "OK") {
        toast.success(data?.data?.msg || "Success");
        //getOwnersMutate();
     
      } else {
        toast.error(data?.data?.msg || "An Error Occured");
      }
      setSelectedData("");
      setShowWhitelabelSettings(false);
  
      //setFetchData(data?.data?.data);
    };
    const onEditWhitelabelSettingError = (data) => {
      setSelectedData("");
      setEditUser(false);
      toast.error(data?.response?.data?.msg || "An Error Occured");
    };
    const { isLoading: whitelabelSettingsLoading, mutate: whitelabelSettingsMutate } = useMutation(
      editWhiteblabelSettings,
      {
        onSuccess: onEditWhitelabelSettingSuccess,
        onError: onEditWhitelabelSettingError,
      }
    );

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{"Partner Wise Collections"}</Title>
              <Underline />
            </div>
          </div>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              // setIsEditLeadVisible={setIsEditLeadVisible}
              t={t}
            />
          </div>

          {editUser && (
            <EditOwnerModel
              editOwnerMutate={editOwnerMutate}
              editEntryLoading={editEntryLoading}
              setEditUser={setEditUser}
              data={data?.data}
              selectedData={selectedData}
            />
          )}
          {showWhitelabelSettings &&
          <WhitelabelSettingsModel
            whitelabelSettingsMutate={whitelabelSettingsMutate}
            whitelabelSettingsLoading={whitelabelSettingsLoading}
            setShowWhitelabelSettings={setShowWhitelabelSettings}
            selectedData={selectedData}
          />
          }
          {uploadLogo && (
            <UploadLogo
              uploadLogoMutate={uploadLogoMutate}
              uploadLogoLoading={uploadLogoLoading}
              setUploadLogo={setUploadLogo}
              selectedData={selectedData}
              data={data?.data}
            />
          )}
          {viewDetail && (
            <ViewDetailModel
              setViewDetail={setViewDetail}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              setUploadLogo={setUploadLogo}
            />
          )}

          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                apiData={fetchData || []}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                userType={user.userType}
                setAddCharges={setAddCharges}
                setUploadLogo={setUploadLogo}
                setShowWhitelabelSettings={setShowWhitelabelSettings}
              />
              {(error || data?.data?.msg == "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>

          <div className="flex gap-4 items-end">
            {filter !== "status" && filter !== "paystatus" ? (
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="filterVal">{("")}</Label>
                <Field
                  className="border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2 ml-1"
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  inputMode={filter === "mobile" ? "numeric" : "text"}
                  maxLength={filter === "mobile" ? "10" : undefined}
                  pattern={filter === "mobile" ? "[0-9]*" : undefined}
                  value={filterValue}
                  onChange={(e) => {
                    if (filter === "mobile") {
                      const value = e.target.value;
                      // Restrict input to digits only, up to 10 characters
                      if (/^\d{0,10}$/.test(value)) {
                        ChangeHandler(e);
                      }
                    } else {
                      ChangeHandler(e);
                    }
                  }}
                />
              </InputGroup>
            ) : filter === "status" ? (
              <InputGroup
                className="min-w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select")}</Label>
                <Select
                  autoComplete="off"
                  className="px-2 bg-transparent text-sm border-none"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                >
                  <MenuItem value="" disabled>
                    {t("Select Status")}
                  </MenuItem>
                  <MenuItem value="3">{t("Active")}</MenuItem>
                  <MenuItem value="4">{t("Enrolled")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null}

            <InputGroup
              className="min-w-[120px]"
              style={{ flexBasis: "content" }}
            >
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setFilterValue("");
                }}
              >
                <MenuItem value="mobile">Phone</MenuItem>
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="status">Status</MenuItem>
                {user.userType !== Config.userType.OPERATION && (
                  <MenuItem value="city">City</MenuItem>
                )}
              </Select>
            </InputGroup>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default RecentUsed;
